import Categories from '../categories/Categories';
import PageBuilder from '../pageBuilder/PageBuilder';

export default {

  name: 'Home',

  inject: ['eventsData'],

  components: {
    'categories-container': Categories,
    'page-builder': PageBuilder
  }

};



// WEBPACK FOOTER //
// ./src/apps/booking/components/home/Home.js